import { useRef, useState } from "react";
import * as Icons from "react-icons/bs";
import { TWindowPosition, Themes } from "../../types";
import useDraggable from "../../hooks/useDraggable";
import '../../scss/lex-doc-rel.scss';
import '../../scss/vintage-controls.scss';

const ExportingModal = ({
  theme,
  format,
}: {
  theme: Themes,
  format: 'docx' | 'pdf',
}) => {
  const [position, setPosition] = useState<TWindowPosition>({ x: 0, y: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const windowRef = useRef<HTMLDivElement>(null);

  const { isDragging, handleMouseDown } = useDraggable({
    initialPosition: position,
    containerRef,
    elementRef: windowRef,
    onPositionChange: (p) => setPosition(p),
    autoAlignToMiddle: true,
  });

  const label = format === 'docx' ? 'Word' : 'PDF';
  const Icon = format === 'docx' ? Icons.BsFileEarmarkWord : Icons.BsFileEarmarkPdf;

  return (
    <div className="full-screen-modal" ref={containerRef}>
      <div
        className={`virtual-window advanced-search-container  ${isDragging ? "dragging" : ""} ${theme}`}
        ref={windowRef}
        style={{
          position: "absolute",
          top: `${position.y}px`,
          left: `${position.x}px`,
          height: '8.5rem',
          width: '25rem',
        }}
      >
        <div className="window-header" onMouseDown={handleMouseDown}>
          <div className="window-title">
            <i className="file-icon">
              <Icon />
            </i>
            <span>Export {label}</span>
          </div>
        </div>
        <div className="window-content d-flex flex-row align-items-center w-100 justify-content-center" style={{ gap: '0.5rem' }}>
          <i className="fa fa-spinner fa-spin" />
          Se genereaza fisierul {label}...
        </div>
        <div className="window-footer" style={{ justifyContent: 'center' }}>
          <span style={{ fontSize: '0.85rem', opacity: 0.7 }}>Va rugam asteptati</span>
        </div>
      </div>
    </div>
  )
}

export default ExportingModal;
